import { WishListProductSelector } from "src/organisms/WishListProductSelector";
import { SizeGuide } from "src/organisms/SizeGuide";
import { Modal } from "src/atoms/Modal";
import { FC, useCallback, useRef, useState } from "react";
import { useBreakpoints } from "@otrium/core";

interface FavouritesSizeSelectorProps {
  productSlug?: string;
  onClose: () => void;
}

const FavouritesSizeSelector: FC<FavouritesSizeSelectorProps> = ({
  productSlug,
  onClose,
}) => {
  const { isMobile } = useBreakpoints();
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
  const [isMobileSizeSelectorOpen, setIsMobileSizeSelectorOpen] =
    useState(false);
  const sizeGuideRef = useRef<HTMLDivElement>(null);
  const [sizeGuideText, setSizeGuideText] = useState<string | null>(null);

  const closeSizeSelector = useCallback(() => {
    setIsSizeGuideOpen(false);
    setIsMobileSizeSelectorOpen(false);
    onClose();
  }, [onClose]);

  const handleOpenSizeGuide = useCallback((text: string) => {
    setSizeGuideText(text);
    setIsSizeGuideOpen(true);
  }, []);
  const handleCloseSizeGuide = useCallback(() => setIsSizeGuideOpen(false), []);

  const handleMobileSizeSelectorOpen = useCallback(() => {
    if (isMobile) {
      setIsMobileSizeSelectorOpen(true);
    }
  }, [isMobile]);

  const handleMobileSizeSelectorClose = useCallback(() => {
    setIsMobileSizeSelectorOpen(false);
  }, []);
  return (
    <>
      <Modal
        isOpen={!!productSlug}
        onClose={closeSizeSelector}
        hasMobileBottomAlign={isMobile}
        fullWidth
        fullHeight={!isMobile}
        rounded
        hidden={isSizeGuideOpen || isMobileSizeSelectorOpen}
      >
        {productSlug && (
          <WishListProductSelector
            onCloseModal={closeSizeSelector}
            productSlug={productSlug}
            onOpenSizeGuide={handleOpenSizeGuide}
            onSizeSelectorOpen={handleMobileSizeSelectorOpen}
            onSizeSelectorClose={handleMobileSizeSelectorClose}
          />
        )}
      </Modal>

      <Modal isOpen={isSizeGuideOpen} onClose={handleCloseSizeGuide}>
        {sizeGuideText !== null && (
          <SizeGuide
            sizeGuide={sizeGuideText}
            onClose={handleCloseSizeGuide}
            ref={sizeGuideRef}
          />
        )}
      </Modal>
    </>
  );
};

export default FavouritesSizeSelector;
